import { TreeViewBaseItem } from '@mui/x-tree-view';
import { useMemo } from 'react';
import { TreeItemData } from '../../../../../components/checkbox-tree-view';

interface UseItemsWithCommaParams {
  searchInputValue: string;
}

export function useItemsWithComma({
  searchInputValue,
}: UseItemsWithCommaParams): TreeViewBaseItem<TreeItemData>[] {
  return useMemo(() => {
    return [
      {
        id: searchInputValue,
        label: searchInputValue,
        value: searchInputValue,
      } as TreeViewBaseItem<TreeItemData>,
    ];
  }, [searchInputValue]);
}
